import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'src/components/tooltip';
import Icon from 'shared/components/icon';
import Stamp from 'src/components/Stamp/Stamp';

const propTypes = {
  showTooltipFlag: PropTypes.bool,
};

const UsCitizensOnlyText = ({showTooltipFlag = false}) => {
  const infoText = 'Only available to US citizens/residents';
  if (!showTooltipFlag) {
    return (
      <Stamp>
        <div className="college-earnings-no-earnings-status-text-content">{infoText}</div>
      </Stamp>
    );
  }

  return (
    <div className="college-earnings-no-earnings-status-text-content">
      <Tooltip title={infoText}>
        <div>
          <Stamp className="flag">
            <Icon iconType="flag" color="grey" />
          </Stamp>
        </div>
      </Tooltip>
    </div>
  );
};
UsCitizensOnlyText.propTypes = propTypes;
export default UsCitizensOnlyText;
